module.exports = __webpack_public_path__ + "media/images/redesign-images/collabs/canva/canva-design-09-8cdc5ca0886fadad5b2935321b4cc2d5.jpg";